import React from 'react'
import Button from '../Button'
import { objectCopy } from 'shared/helpers/general'
import Pagination from '../Pagination'

function DataTable({ pagination, data, structure, title, onRowClick = () => {}, actions = [], emptyLabel = 'No data available' }) {
  
  const [currentPage, setCurrentPage] = React.useState(1)
  const perPage = pagination?.perPage || 20
  const totalItems = data.length
  const totalPages = Math.ceil(totalItems / perPage)

  const items = pagination
    ? objectCopy(data).slice((currentPage - 1) * perPage, currentPage * perPage)
    : data

  
  
  return (
    <div>
      {(title || actions.length > 0) && (
        <div className="my-[16px] flex items-center justify-between">
          {title && <div className="font-medium opacity-70">{title}</div>}
          {actions.length > 0 && (
            <div className="flex items-center">
              {actions.map((a, index) => (
                <Button
                  key={index}
                  size="small"
                  className="ml-[16px] first:ml-[0]"
                  variant="secondary"
                  rounded
                  onClick={a.action}
                >
                  {a.label}
                </Button>
              ))}
            </div>
          )}
        </div>
      )}
      <div className="data-table mt-[16px]">
        <table className="table table-fixed w-full">
          <thead>
            <tr>
              {structure.map((i, index) => (
                <th
                  key={index}
                  className="px-4 py-2 text-left"
                  style={{ width: i.width || 'auto' }}
                >
                  {i.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {items.map((d, rowIndex) => (
              <tr key={rowIndex}>
                {structure.map((i, colIndex) => (
                  <td
                    key={colIndex}
                    className="px-4 py-2 truncate"
                    style={{ width: i.width || 'auto', maxWidth: i.width || 'auto' }}
                    onClick={() => {
                      onRowClick(d, rowIndex + (currentPage - 1) * perPage)
                    }}
                  >
                    <div className="overflow-hidden text-ellipsis whitespace-nowrap">
                      {i.data ? i.data(d) : '-'}
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        {items.length === 0 && (
          <div className="p-[16px] text-sm font-normal opacity-70">{emptyLabel}</div>
        )}
      </div>
      {pagination && totalPages > 1 && <Pagination data={data} onPageChange={setCurrentPage} perPage={perPage}/>}
    </div>
  )
}

export default DataTable
